import { createDefaultChirpClient } from '../chirpClient';
import { getAblyAuthTokenRpc } from '../../../__generated__/chirp/com/hubspot/breeze/orch/rpc/BreezeAssistantOrchAuthService';
import { retrieveAuthTokenRpc } from '../../../__generated__/chirp/com/hubspot/academy/assistant/rpc/ChatRpc';
const defaultClient = createDefaultChirpClient();
function makeTokenFn(rpc, chirpClient = defaultClient) {
  return async conversationId => {
    const response = await chirpClient.call(rpc, {
      request: {
        conversationId
      }
    });
    return {
      token: response.token,
      channelId: response.channelId
    };
  };
}

/**
 * Maps agent IDs to their agent-specific Ably auth RPCs.
 * To support a new agent: import its auth RPC and add an entry here.
 * Both ABLY_AUTH_REGISTRY and makeImpersonatingAblyTokenFn derive from this map.
 */
const ABLY_RPC_BY_AGENT = {
  'breeze-assistant-breeze-engine': getAblyAuthTokenRpc,
  'academy-assistant': retrieveAuthTokenRpc
};

/**
 * Maps agent IDs to their Ably auth token functions using the default
 * app-auth CHIRP client. Suitable for use in apps with standard cookie auth.
 */
export const ABLY_AUTH_REGISTRY = Object.fromEntries(Object.entries(ABLY_RPC_BY_AGENT).map(([agentId, rpc]) => [agentId, makeTokenFn(rpc)]));

/**
 * Returns an AblyTokenFn for the given agent using a provided chirpClient,
 * so token requests use the caller's auth context (e.g. portal impersonation
 * in internal-ui). Each agent's own auth RPC is preserved. Returns undefined
 * when the agent is not in ABLY_RPC_BY_AGENT.
 */
export function makeImpersonatingAblyTokenFn(chirpClient, agentId) {
  const rpc = ABLY_RPC_BY_AGENT[agentId];
  if (rpc == null) return undefined;
  return makeTokenFn(rpc, chirpClient);
}